<template>
  <div id="app">
    <router-view :api="server"></router-view>
  </div>
</template>

<script>

const axios = require('axios')

export default {
  name: 'App',
  data() {
    return {
      server: axios
    }
  },
  created() {
    document.title = 'BoosterLearn'
  }

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
@media (max-width: 640px) {
    body {
        padding: 0 0 0 0 !important;
        margin-top: 0px;
        height: 100% !important;
        background-color: rgba(0,0,0,0);
    }
    #app {
      margin-top: 0px;
      height: 100% !important;
    }
    .ui.segment {
      border: 1px solid #1b364f;
      border-radius: 0px !important;
    }
}
</style>
